import React, { useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { useSelector, useDispatch } from 'react-redux'

import Spinner from './components/shared/Spinner'
import { isLoading as getIsLoading } from './auth/selectors'
import { initAuth, initContactUnderwriters } from './auth/actions'

import './app.scss'

const AppInitializer = ({ children }) => {
  const { authState } = useOktaAuth()
  const dispatch = useDispatch()
  const isLoading = useSelector(getIsLoading)

  useEffect(() => {
    if (authState?.isAuthenticated) {
      dispatch(initAuth())
    } else if (authState && !authState.isAuthenticated) {
      dispatch(initContactUnderwriters())
    }
  }, [authState?.isAuthenticated, dispatch])

  const transitionAuthenticated =
    authState &&
    typeof authState?.isAuthenticated === 'boolean' &&
    authState?.isAuthenticated === true

  if (isLoading && transitionAuthenticated) {
    return (
      <div className="loading-app-overlay">
        <Spinner />
      </div>
    )
  }

  return children
}

export default AppInitializer
